import React from 'react';

import pc_bg from "@/assets/a-pc-bg.png";
import iconQRCode from "@/assets/ic_qrcode@2x.png";
import QrCodeImg from "@/assets/download-qrcode.png";

// Service icons
import serviceIcon1 from "@/assets/box_icon@3x.png";
import serviceIcon2 from "@/assets/pic_truck@2x.png";
import serviceIcon3 from "@/assets/pallet_icon@3x.png";
import serviceIcon4 from "@/assets/location_icon@3x.png";

// Other assets
import checkIcon from "@/assets/ic_check@2x.png";
import mobileAppImage from "@/assets/pic_phone@3x.png";
import truckImage from "@/assets/pic_truck@2x.png";

// Downloaded images
import heroBackground from "@/assets/hero-background.webp";
import serviceEcommerceDesktop from "@/assets/service-ecommerce-desktop.png";
import serviceFurnitureDesktop from "@/assets/service-furniture-desktop.png";
import serviceTradeDesktop from "@/assets/service-trade-desktop.png";
import serviceBusinessDesktop from "@/assets/service-business-desktop.png";
import serviceEcommerceMobile from "@/assets/service-ecommerce-mobile.png";
import serviceFurnitureMobile from "@/assets/service-furniture-mobile.png";
import serviceTradeMobile from "@/assets/service-trade-mobile.png";
import serviceBusinessMobile from "@/assets/service-business-mobile.png";
import checkIconAdvantage from "@/assets/check-icon.png";
import truckAdvantages from "@/assets/truck-advantages.png";
import platformStep1Desktop from "@/assets/platform-step1-desktop.png";
import platformStep2Desktop from "@/assets/platform-step2-desktop.png";
import platformStep3Desktop from "@/assets/platform-step3-desktop.png";
import platformStep4Desktop from "@/assets/platform-step4-desktop.png";
import platformStep1Mobile from "@/assets/platform-step1-mobile.png";
import platformStep2Mobile from "@/assets/platform-step2-mobile.png";
import platformStep3Mobile from "@/assets/platform-step3-mobile.png";
import platformStep4Mobile from "@/assets/platform-step4-mobile.png";
import ctaBackground from "@/assets/cta-background.png";
import testimonial1 from "@/assets/testimonial1.png";
import testimonial2 from "@/assets/testimonial2.png";
import testimonial3 from "@/assets/testimonial3.png";
import stats3000users from "@/assets/stats-3000users.png";
import stats48states from "@/assets/stats-48states.png";
import statsSatisfaction from "@/assets/stats-satisfaction.png";
import statsOntime from "@/assets/stats-ontime.png";
import statsMobile1 from "@/assets/stats-mobile1.png";
import statsMobile2 from "@/assets/stats-mobile2.png";
import statsMobile3 from "@/assets/stats-mobile3.png";
import statsMobile4 from "@/assets/stats-mobile4.png";
import mobileApp from "@/assets/mobile-app.png";
import appLogo from "@/assets/app-logo.png";
import contactIcon from "@/assets/contact-icon.png";
import wechatQr from "@/assets/wechat-qr.png";

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative h-[560px] lg:h-[537px] overflow-hidden">
        {/* Background */}
        <div
          className="absolute inset-0 bg-cream"
          style={{
            clipPath: "polygon(0 0, 100% 0, 100% 85%, 50% 100%, 0 85%)",
          }}
        >
          <div
            className="w-full h-full bg-cover bg-center opacity-60"
            style={{
              backgroundImage: `url(${heroBackground})`,
            }}
          />
        </div>

        {/* Hero Content */}
        <div className="relative z-10 max-w-7xl mx-auto px-4 lg:px-8 h-full flex items-center">
          <div className="lg:ml-auto lg:max-w-md">
            <div className="text-center lg:text-right mb-6">
              <h1 className="text-white text-2xl lg:text-[40px] font-normal leading-tight mb-2">
                专为在美华人商户打造
              </h1>
              <h2 className="text-white text-2xl lg:text-[40px] font-normal leading-tight">
                拼货物流平台
              </h2>
            </div>

            <div className="space-y-4">
              {/* Desktop CTAs */}
              <div className="hidden lg:flex gap-6">
                <button className="bg-brand-blue text-white px-8 py-4 rounded-lg text-[17px] font-semibold">
                  免费估价
                </button>
                <button className="bg-white border border-brand-blue text-brand-blue px-8 py-4 rounded-lg text-[17px] font-semibold">
                  联系我们
                </button>
              </div>

              {/* Mobile CTAs */}
              <div className="lg:hidden space-y-2">
                <button className="w-full bg-brand-blue text-white py-3 rounded-lg text-base font-semibold">
                  APP下载
                </button>
                <button className="w-full bg-white border border-brand-blue text-brand-blue py-3 rounded-lg text-base font-semibold">
                  免费估价
                </button>
              </div>

              {/* App Download Button */}
              <div className="hidden lg:flex items-center gap-6">
                <div className="flex rounded-lg overflow-hidden">
                  <button className="bg-brand-blue text-white px-10 py-4 text-[17px] font-semibold">
                    APP下载
                  </button>
                  <div className="bg-brand-blue p-4 relative">
                    <div className="absolute inset-0 bg-white opacity-20"></div>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect
                        x="3"
                        y="3"
                        width="18"
                        height="18"
                        rx="3"
                        stroke="white"
                        strokeWidth="2"
                      />
                      <path
                        d="M9 12l2 2 4-4"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Service Objects Section */}
      <section className="py-12 lg:py-16">
        <div className="max-w-7xl mx-auto px-4 lg:px-8">
          <h2 className="text-black text-[22px] lg:text-[32px] font-normal text-center mb-8 lg:mb-10">
            我们的服务对象
          </h2>

          {/* Desktop Grid */}
          <div className="hidden lg:grid grid-cols-4 gap-8">
            {[
              {
                image: serviceEcommerceDesktop,
                label: "跨境电商",
              },
              {
                image: serviceFurnitureDesktop,
                label: "家具、大件货物商家",
              },
              {
                image: serviceTradeDesktop,
                label: "中美进口贸易商",
              },
              {
                image: serviceBusinessDesktop,
                label: "本土中小企业",
              },
            ].map((item, index) => (
              <div key={index} className="relative">
                <img
                  src={item.image}
                  alt={item.label}
                  className="w-full h-[200px] object-cover rounded-3xl"
                />
                <div className="absolute top-2 left-3 bg-black text-white px-2 py-2 rounded-lg text-[17px]">
                  {item.label}
                </div>
              </div>
            ))}
          </div>

          {/* Mobile List */}
          <div className="lg:hidden space-y-4">
            {[
              {
                image: serviceEcommerceMobile,
                label: "跨境电商",
              },
              {
                image: serviceFurnitureMobile,
                label: "家具、大件货物商家",
              },
              {
                image: serviceTradeMobile,
                label: "中美进口贸易商",
              },
              {
                image: serviceBusinessMobile,
                label: "本土中小企业",
              },
            ].map((item, index) => (
              <div key={index} className="flex items-center gap-4 px-4">
                <img
                  src={item.image}
                  alt={item.label}
                  className="w-20 h-20 object-cover rounded-2xl"
                />
                <div className="bg-black text-white px-2 py-2 rounded-lg text-[17px]">
                  {item.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Advantages Section */}
      <section className="bg-black rounded-[27px] mx-4 lg:mx-8 mb-12 lg:mb-16 relative overflow-hidden">
        <div className="relative z-10 max-w-7xl mx-auto px-4 lg:px-8 py-16 lg:py-24">
          <h2 className="text-white text-[22px] lg:text-[32px] font-normal text-center lg:text-left mb-8 lg:mb-12">
            我们的优势
          </h2>

          <div className="lg:flex lg:items-center lg:gap-8">
            {/* Problems */}
            <div className="lg:w-1/3 mb-8 lg:mb-0">
              <div className="text-gray-light text-base lg:text-[22px] leading-8 space-y-2">
                <p>英文系统用不惯？</p>
                <p>找不到性价比高的拼货渠道？</p>
                <p>报价不透明，流程复杂？</p>
              </div>
            </div>

            {/* Solutions */}
            <div className="lg:w-1/3">
              <div className="space-y-4">
                {[
                  "中文客服对接",
                  "提供优质拼货方案，免费估价",
                  "报价透明/实时追踪",
                ].map((solution, index) => (
                  <div
                    key={index}
                    className="flex items-center gap-3 bg-gray-dark bg-opacity-60 rounded-lg p-3"
                  >
                    <img
                      src={checkIconAdvantage}
                      alt="Check"
                      className="w-6 h-6 rounded-full"
                    />
                    <span className="text-white text-base lg:text-[22px] font-semibold">
                      {solution}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            {/* Image */}
            <div className="lg:w-1/3 mt-8 lg:mt-0">
              <img
                src={truckAdvantages}
                alt="Truck"
                className="w-full rounded-3xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* How to Use Platform Section */}
      <section className="py-12 lg:py-16">
        <div className="max-w-7xl mx-auto px-4 lg:px-8">
          <h2 className="text-black text-[22px] lg:text-[32px] font-normal text-center mb-8 lg:mb-12">
            如何使用我们的平台
          </h2>

          {/* Desktop Grid */}
          <div className="hidden lg:grid grid-cols-4 gap-8">
            {[
              {
                image: platformStep1Desktop,
                badge: "免费估价",
                step: "第一步",
                description: "免登录输入基本信息\n三十秒钟免费估价",
              },
              {
                image: platformStep2Desktop,
                badge: "货物详情",
                step: "第二步",
                description: "填写详细货物和地址信息\n确认下单付款",
              },
              {
                image: platformStep3Desktop,
                badge: "匹配司机",
                step: "第三步",
                description: "平台匹配司机接单\n司机联系取货",
              },
              {
                image: platformStep4Desktop,
                badge: "全程追踪",
                step: "第四步",
                description: "平台实时查询货物状态\n确认货物送达",
              },
            ].map((item, index) => (
              <div key={index} className="text-center">
                <div className="relative mb-4">
                  <div className="absolute top-0 left-1/2 transform -translate-x-1/2 bg-brand-blue text-white px-4 py-1 rounded-lg text-sm font-semibold z-10">
                    {item.badge}
                  </div>
                  <img
                    src={item.image}
                    alt={item.step}
                    className="w-full h-[200px] object-cover rounded-lg mt-3"
                  />
                </div>
                <h3 className="text-black text-[17px] font-semibold mb-2">
                  {item.step}
                </h3>
                <p className="text-gray-dark text-[17px] whitespace-pre-line">
                  {item.description}
                </p>
              </div>
            ))}
          </div>

          {/* Mobile List */}
          <div className="lg:hidden space-y-6">
            {[
              {
                image: platformStep1Mobile,
                badge: "免费估价",
                step: "第一步",
                description: "免登录输入基本信息\n三十秒钟免费估价",
              },
              {
                image: platformStep2Mobile,
                badge: "货物详情",
                step: "第二步",
                description: "填写详细货物和地址信息\n确认下单付款",
              },
              {
                image: platformStep3Mobile,
                badge: "匹配司机",
                step: "第三步",
                description: "平台匹配司机接单\n司机联系取货",
              },
              {
                image: platformStep4Mobile,
                badge: "全程追踪",
                step: "第四步",
                description: "平台实时查询货物状态\n确认货物送达",
              },
            ].map((item, index) => (
              <div key={index} className="flex items-start gap-4 px-4">
                <div className="flex flex-col items-center">
                  <div className="bg-brand-blue text-white px-3 py-1 rounded-lg text-sm font-semibold mb-2">
                    {item.badge}
                  </div>
                  <img
                    src={item.image}
                    alt={item.step}
                    className="w-20 h-20 object-cover rounded-lg"
                  />
                </div>
                <div className="flex-1">
                  <h3 className="text-black text-base font-semibold mb-2">
                    {item.step}
                  </h3>
                  <p className="text-gray-dark text-base whitespace-pre-line">
                    {item.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Quote Section */}
      <section className="relative overflow-hidden mb-12 lg:mb-16">
        <div className="relative">
          <img
            src={ctaBackground}
            alt="Background"
            className="w-full h-[312px] lg:h-[301px] object-cover rounded-3xl"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-white/90 via-white/50 to-transparent"></div>

          <div className="absolute inset-0 flex items-center">
            <div className="max-w-7xl mx-auto px-4 lg:px-8 w-full">
              <div className="lg:max-w-2xl">
                <h2 className="text-black text-[22px] lg:text-[32px] font-semibold mb-4">
                  立即获得免费估价
                </h2>
                <p className="text-black text-base lg:text-[17px] mb-8">
                  无需注册，三十秒钟即可体验完整报价流程
                </p>

                <div className="lg:hidden">
                  <button className="w-full bg-brand-blue text-white py-3 rounded-lg text-base font-semibold">
                    免费估价
                  </button>
                </div>

                <div className="hidden lg:flex items-end gap-8">
                  {/* Form Fields */}
                  <div className="flex gap-4">
                    <div className="bg-white rounded shadow-lg p-4 min-w-[200px]">
                      <label className="text-gray-dark text-sm mb-2 block">
                        发货点
                      </label>
                      <div className="flex items-center gap-2">
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <path
                            d="M10.3617 8.24737C10.723 7.97817 10.9867 7.60902 11.1161 7.19126C11.2455 6.77351 11.2343 6.32794 11.0839 5.91653C10.9335 5.50513 10.6515 5.14835 10.277 4.89583C9.90258 4.64331 9.45436 4.50761 8.9947 4.50761C8.53504 4.50761 8.08681 4.64331 7.71237 4.89583C7.33793 5.14835 7.0559 5.50513 6.90551 5.91653C6.75512 6.32794 6.74386 6.77351 6.87329 7.19126C7.00271 7.60902 7.26639 7.97817 7.62765 8.24737C7.00863 8.48227 6.46852 8.87187 6.0649 9.37463C5.66127 9.8774 5.40925 10.4745 5.33572 11.1022C5.3304 11.1481 5.33466 11.1944 5.34826 11.2387C5.36186 11.283 5.38453 11.3243 5.41498 11.3603C5.47648 11.4329 5.56594 11.4794 5.66366 11.4896C5.76139 11.4998 5.85938 11.4728 5.93609 11.4146C6.01279 11.3563 6.06192 11.2716 6.07267 11.179C6.15359 10.4968 6.49704 9.86669 7.03743 9.40914C7.57781 8.95159 8.27724 8.69865 9.00207 8.69865C9.7269 8.69865 10.4263 8.95159 10.9667 9.40914C11.5071 9.86669 11.8505 10.4968 11.9315 11.179C11.9415 11.2648 11.9847 11.344 12.0527 11.4013C12.1208 11.4587 12.2088 11.4902 12.2999 11.4896H12.3405C12.4371 11.4791 12.5253 11.4328 12.5861 11.3609C12.6468 11.289 12.6751 11.1973 12.6647 11.1057C12.5908 10.4762 12.3375 9.87757 11.9318 9.37403C11.5261 8.8705 10.9833 8.48103 10.3617 8.24737Z"
                            fill="black"
                          />
                        </svg>
                        <span className="text-gray-text text-sm">
                          Zip code / city name
                        </span>
                      </div>
                    </div>

                    <div className="bg-white rounded shadow-lg p-4 min-w-[200px]">
                      <label className="text-gray-dark text-sm mb-2 block">
                        收货点
                      </label>
                      <div className="flex items-center gap-2">
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <path
                            d="M10.3617 8.24737C10.723 7.97817 10.9867 7.60902 11.1161 7.19126C11.2455 6.77351 11.2343 6.32794 11.0839 5.91653C10.9335 5.50513 10.6515 5.14835 10.277 4.89583C9.90258 4.64331 9.45436 4.50761 8.9947 4.50761C8.53504 4.50761 8.08681 4.64331 7.71237 4.89583C7.33793 5.14835 7.0559 5.50513 6.90551 5.91653C6.75512 6.32794 6.74386 6.77351 6.87329 7.19126C7.00271 7.60902 7.26639 7.97817 7.62765 8.24737C7.00863 8.48227 6.46852 8.87187 6.0649 9.37463C5.66127 9.8774 5.40925 10.4745 5.33572 11.1022C5.3304 11.1481 5.33466 11.1944 5.34826 11.2387C5.36186 11.283 5.38453 11.3243 5.41498 11.3603C5.47648 11.4329 5.56594 11.4794 5.66366 11.4896C5.76139 11.4998 5.85938 11.4728 5.93609 11.4146C6.01279 11.3563 6.06192 11.2716 6.07267 11.179C6.15359 10.4968 6.49704 9.86669 7.03743 9.40914C7.57781 8.95159 8.27724 8.69865 9.00207 8.69865C9.7269 8.69865 10.4263 8.95159 10.9667 9.40914C11.5071 9.86669 11.8505 10.4968 11.9315 11.179C11.9415 11.2648 11.9847 11.344 12.0527 11.4013C12.1208 11.4587 12.2088 11.4902 12.2999 11.4896H12.3405C12.4371 11.4791 12.5253 11.4328 12.5861 11.3609C12.6468 11.289 12.6751 11.1973 12.6647 11.1057C12.5908 10.4762 12.3375 9.87757 11.9318 9.37403C11.5261 8.8705 10.9833 8.48103 10.3617 8.24737Z"
                            fill="black"
                          />
                        </svg>
                        <span className="text-gray-text text-sm">
                          Zip code / city name
                        </span>
                      </div>
                    </div>
                  </div>

                  <button className="bg-brand-blue text-white px-8 py-4 rounded-lg text-[17px] font-semibold">
                    免费估价
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Customer Testimonials Section */}
      <section className="py-12 lg:py-16">
        <div className="max-w-7xl mx-auto px-4 lg:px-8">
          <h2 className="text-black text-[22px] lg:text-[32px] font-normal text-center mb-8 lg:mb-12">
            来自华人客户的评价
          </h2>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {[
              {
                image: testimonial1,
                text: "本人英语一般，在试用了几次全英语货运平台以后总是有些地方搞不清楚，朋友推荐了这个中文平台后确实简单省心了很多，客服也可以中文沟通，态度很好！\n\n- 商家Sam (San Jose, CA)",
                gradient: "from-gray-100 to-gray-300",
              },
              {
                image: testimonial2,
                text: "我在洛杉矶开家具店，经常要给客户安排大件派送。这家货运公司效率高，预约灵活，还能直接送进门。客户满意，我们也省了很多人力，已经合作半年了，打算继续长期合作。\n\n- 商家Qinyi（LA, CA)",
                gradient: "from-gray-50 to-gray-400",
              },
              {
                image: testimonial3,
                text: "美国本地货运真不便宜，但他们家价格透明公道，没有乱收费。大件运输、搬运方式也都有提前沟��，服务很好。试用了好几个货运平台之后还是觉得他们最靠谱。\n\n- 个人用户Ming（LA, CA)",
                gradient: "from-gray-200 to-gray-500",
              },
            ].map((testimonial, index) => (
              <div
                key={index}
                className={`bg-gradient-to-b ${testimonial.gradient} rounded-3xl p-6 lg:p-12`}
              >
                <img
                  src={testimonial.image}
                  alt="Customer"
                  className="w-20 h-20 rounded-3xl mb-4"
                />
                <p className="text-black text-sm lg:text-[17px] whitespace-pre-line leading-relaxed">
                  "{testimonial.text}"
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose ExtraSpace Section */}
      <section className="py-12 lg:py-16">
        <div className="max-w-7xl mx-auto px-4 lg:px-8">
          <h2 className="text-black text-[22px] lg:text-[32px] font-normal text-center mb-8 lg:mb-12">
            为什么选择ExtraSpace
          </h2>

          {/* Desktop Grid */}
          <div className="hidden lg:grid grid-cols-12 grid-rows-6 gap-6 h-[800px]">
            {/* 3000+ Users Card */}
            <div className="col-span-6 row-span-3 relative overflow-hidden rounded-3xl">
              <img
                src={stats3000users}
                alt="Background"
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/45 to-transparent"></div>
              <div className="relative z-10 p-8 h-full flex flex-col justify-center">
                <h3 className="text-white text-[17px] font-semibold mb-2">
                  服务华人商户
                </h3>
                <div className="text-white text-[80px] font-bold leading-none">
                  3000+
                </div>
              </div>
            </div>

            {/* 48 States Card */}
            <div className="col-span-6 row-span-4 bg-gray-light rounded-3xl relative overflow-hidden">
              <img
                src={stats48states}
                alt="Map"
                className="absolute bottom-0 left-4 w-4/5 opacity-60"
              />
              <div className="relative z-10 p-8">
                <h3 className="text-black text-[17px] font-semibold mb-2">
                  覆盖全美
                </h3>
                <div className="text-black text-[64px] font-bold leading-none">
                  48州
                </div>
              </div>
            </div>

            {/* 98.8% Satisfaction Card */}
            <div className="col-span-5 row-span-3 relative overflow-hidden rounded-3xl">
              <img
                src={statsSatisfaction}
                alt="Background"
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="relative z-10 p-8 h-full flex flex-col justify-between">
                <h3 className="text-white text-[17px] font-semibold">
                  客户满意度
                </h3>
                <div>
                  <div className="text-white text-[96px] font-bold leading-none mb-4">
                    98.8%
                  </div>
                  <p className="text-white text-[17px]">
                    超过九成用户愿意再次选择我们，你也可以。
                  </p>
                </div>
              </div>
            </div>

            {/* 90% On-time Card */}
            <div className="col-span-7 row-span-2 relative overflow-hidden rounded-3xl">
              <img
                src={statsOntime}
                alt="Background"
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="relative z-10 p-8 h-full flex flex-col justify-center">
                <h3 className="text-brand-green-secondary text-[17px] font-semibold mb-2">
                  高效送达
                </h3>
                <div className="text-brand-green text-[64px] font-bold leading-none">
                  准点率 90%
                </div>
              </div>
            </div>
          </div>

          {/* Mobile Stack */}
          <div className="lg:hidden space-y-4">
            <img
              src={statsMobile1}
              alt="Statistics"
              className="w-full rounded-3xl"
            />
            <img
              src={statsMobile2}
              alt="Statistics"
              className="w-full rounded-3xl"
            />
            <img
              src={statsMobile3}
              alt="Statistics"
              className="w-full rounded-3xl"
            />
            <img
              src={statsMobile4}
              alt="Statistics"
              className="w-full rounded-3xl"
            />
          </div>
        </div>
      </section>

      {/* App Download Section */}
      <section className="relative py-12 lg:py-16">
        <div className="absolute inset-0 bg-gray-300"></div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 lg:px-8">
          <div className="lg:flex lg:items-center lg:gap-16">
            {/* Mobile App Image */}
            <div className="lg:w-1/2 mb-8 lg:mb-0 flex justify-center">
              <img
                src={mobileApp}
                alt="Mobile App"
                className="max-w-[300px] lg:max-w-[400px]"
              />
            </div>

            {/* Content */}
            <div className="lg:w-1/2">
              {/* Tab Selector */}
              <div className="border-2 border-brand-blue rounded-lg p-2 w-full lg:w-[400px] mb-8">
                <div className="flex">
                  <button className="flex-1 bg-gray-dark text-white py-3 rounded-lg text-[18px] font-semibold">
                    用户端
                  </button>
                  <button className="flex-1 text-black py-3 text-[18px] font-semibold">
                    司机端
                  </button>
                </div>
              </div>

              {/* Logo */}
              <img
                src={appLogo}
                alt="ExtraSpace Logo"
                className="mb-8 h-12"
              />

              {/* Description */}
              <p className="text-black text-base lg:text-[17px] mb-8 leading-relaxed">
                加入ExtraSpace，充分利用您的运输资源，释放您货车的全部潜力，为您创造更多收益！我们期待您的加入，让我们一起打造更智能、更高效的运输未来！
              </p>

              {/* Features */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-8">
                {[
                  "在线发布订单",
                  "订单实时跟踪",
                  "历史订单查询",
                  "信用卡支付",
                ].map((feature, index) => (
                  <div key={index} className="flex items-center gap-3">
                    <div className="w-6 h-6 bg-brand-green-secondary rounded-full flex items-center justify-center">
                      <svg
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M10.3536 2.64645C10.5488 2.84171 10.5488 3.15829 10.3536 3.35355L4.85355 8.85355C4.65829 9.04882 4.34171 9.04882 4.14645 8.85355L1.64645 6.35355C1.45118 6.15829 1.45118 5.84171 1.64645 5.64645C1.84171 5.45118 2.15829 5.45118 2.35355 5.64645L4.5 7.79289L9.64645 2.64645C9.84171 2.45118 10.1583 2.45118 10.3536 2.64645Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <span className="text-black text-base lg:text-[17px] font-semibold">
                      {feature}
                    </span>
                  </div>
                ))}
              </div>

              {/* Download Button */}
              <div className="flex rounded-lg overflow-hidden w-fit">
                <button className="bg-brand-blue text-white px-10 py-4 text-[17px] font-semibold">
                  APP下载
                </button>
                <div className="bg-brand-blue p-4 relative">
                  <div className="absolute inset-0 bg-white opacity-20"></div>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect
                      x="3"
                      y="3"
                      width="18"
                      height="18"
                      rx="3"
                      stroke="white"
                      strokeWidth="2"
                    />
                    <path
                      d="M9 12l2 2 4-4"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="bg-gray-dark lg:bg-gray-600">
        <div className="max-w-7xl mx-auto px-4 lg:px-8 py-8 lg:py-16">
          <div className="lg:flex lg:items-center lg:justify-between">
            {/* Contact Info */}
            <div className="lg:w-1/2">
              <div className="flex items-center gap-4 mb-6">
                <img
                  src={contactIcon}
                  alt="Contact"
                  className="w-9 h-9"
                />
                <h2 className="text-white text-2xl font-normal">联系我们</h2>
              </div>

              <p className="text-white text-sm lg:text-base mb-6 leading-relaxed">
                请扫描二维码添加微信客服，专业客服在线支持；也可以加入华人物流交流群参与讨论。等您参与，我们期待您的到来！
              </p>

              <button className="bg-brand-blue text-white px-8 py-3 rounded-lg text-base font-semibold mb-6">
                邮件沟通
              </button>
            </div>

            {/* WeChat QR */}
            <div className="lg:w-1/2 lg:flex lg:justify-end">
              <div className="text-center">
                <img
                  src={wechatQr}
                  alt="WeChat QR Code"
                  className="w-24 h-24 lg:w-32 lg:h-32 mx-auto mb-4 rounded-lg shadow-lg"
                />
                <p className="text-white text-sm lg:text-base">添加微信客服</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}